import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const BORDER = {
  borderRightWidth: 1,
  borderRightColor: "#000",
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 90,
    paddingBottom: 90,
    paddingHorizontal: 20,
    fontSize: 10,
  },

  headerText: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },

  subHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 5,
  },

  // tableContainer: {
  //   width: "100%",
  //   borderWidth: 1,
  //   borderColor: "#000",
  //   marginTop: 10,
  // },
  tableContainer: {
    width: "100%",
    // borderLeftWidth: 1,
    // borderRightWidth: 1,
    // borderBottomWidth: 1,
    // borderColor: "#000",
    marginTop: 10,
  },

  tableHeaderRow: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    // minHeight: 20,
  },

  /* ---------- HEADERS ---------- */
  tableColHeader1: { width: 30, padding: 5, textAlign: "center", fontWeight: "bold", ...BORDER },
  tableColHeader2: { width: 40, padding: 5, textAlign: "center", fontWeight: "bold", ...BORDER },
  tableColHeader: { width: 70, padding: 5, textAlign: "center", fontWeight: "bold", ...BORDER },
  tableColHeaderSmall: { width: 80, padding: 5, textAlign: "center", fontWeight: "bold", ...BORDER },
  tableColHeaderDescription: { flex: 1, padding: 5, textAlign: "center", fontWeight: "bold", ...BORDER },

  /* ---------- ROWS ---------- */
  tableCol1: { width: 30, padding: 5, textAlign: "center", ...BORDER },
  tableCol: { width: 70, padding: 5, ...BORDER },
  tableColSmall: { width: 80, padding: 5, ...BORDER },
  tableColDescription: { flex: 1, padding: 5, flexWrap: "wrap", ...BORDER },
  tableCol1hrs: { width: 40, padding: 5, textAlign: "right", ...BORDER },


  empheaderText: {
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 10,
  },
  emptableContainer: {
    display: "table",
    width: "100%",
    borderTopWidth: 1,
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
    borderBottomWidth: 0
  },
  emptableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  emptableColHeader1: {
    width: 35, // S.No
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableCol1: {
    width: 35, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  emptableColHeaderProject: {
    width: "20%", // Project column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColProject: {
    width: "20%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  emptableColHeaderEmp: {
    width: "80%", // Employee Name column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColEmp: {
    width: "80%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  emptableColHeaderhrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColHeaderTotlActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableCol1hrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  emptableCol1ToalActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },

  //list of Project tasks

  prjpage: {
    padding: 20,
    fontSize: 10,
  },
  prjheaderText: {
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 10,
  },
  prjtableContainer: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
    borderBottomWidth: 0,
    borderTopWidth: 1
  },
  prjtableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  prjtableColHeader1: {
    width: 35, // S.No
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableCol1: {
    width: 35, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  prjtableColHeaderProject: {
    width: "100%", // Project column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColProject: {
    width: "100%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  prjtableColHeaderEmp: {
    width: "80%", // Employee Name column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColEmp: {
    width: "80%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  prjtableColHeaderhrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColHeadeProjActrhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },

  prjtableCol1hrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  prjtableCol1ProjActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  prjtableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  prjtableCol1: {
    width: 35, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },


  headerWrapper: {
    position: "absolute",
    top: 20,
    left: 20,
    right: 20,
    height: 60,
    alignItems: "center",
  },

  headerImage: {
    width: "100%",
    height: 60,
    objectFit: "contain",
  },

  footerWrapper: {
    position: "absolute",
    bottom: 20,
    left: 5,
    right: 5,
    height: 80,
  },
});

const groupByEmployee = (data) => {
  return data.reduce((acc, row) => {
    if (!acc[row.EmployeeName]) acc[row.EmployeeName] = [];
    acc[row.EmployeeName].push(row);
    return acc;
  }, {});
};

const formatDate = (inputDate) => {
  if (!inputDate) return "";
  const [y, m, d] = inputDate.split("-");
  return `${d}-${m}-${y}`;
};

const PSRreportPageBreak_v1 = ({
  data = [],
  filters = {},
  projectName = "",
  managerName = "",
  employeeTaskData = [],
  projectTaskData = [],
  footerHeight
}) => {
  const groupedByEmployee = groupByEmployee(data);

  return (
    <Document>

      {/* ================= MAIN REPORT ================= */}
      {Object.entries(groupedByEmployee).map(([employeeName, records], empIndex) => {
        const isFirstPage = empIndex === 0;

        return (
          <Page size="A4" orientation="landscape"
            // style={styles.page} 
            style={{
              paddingBottom: footerHeight,
              paddingTop: 90,
              paddingHorizontal: 20,
              fontSize: 10,
            }}
            key={empIndex}>

            {/* HEADER */}
            <View fixed style={styles.headerWrapper}>
              {filters.HeaderImg && (
                <Image
                  src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                  style={styles.headerImage}
                />
              )}
            </View>

            {/* FIRST PAGE HEADER */}
            {isFirstPage && (
              <>
                <Text style={styles.headerText}>
                  {`Project Status Report - ${filters.EmployeeID} ${filters.FromDate && filters.ToDate
                    ? `(${formatDate(filters.FromDate)} to ${formatDate(filters.ToDate)})`
                    : ""
                    }`}
                </Text>

                <Text style={styles.subHeaderText}>{`Project: ${projectName}`}</Text>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                  {managerName && (
                    <Text style={styles.subHeaderText}>{`Manager: ${managerName}`}</Text>
                  )}
                  <Text style={styles.subHeaderText}>E.Hrs - Estimated Hours</Text>
                </View>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                  <Text style={styles.subHeaderText}>
                    {"Comp -> Completed | Appr -> Approved"}
                  </Text>
                  <Text style={styles.subHeaderText}>
                    A.Hrs - Actual Hours
                  </Text>
                </View>
              </>
            )}

            <Text style={{ fontWeight: "bold", marginTop: 5 }}>
              Employee Name: {employeeName}
            </Text>

            {/* TABLE */}
            <View style={styles.tableContainer}>
              <View fixed>
                <View style={styles.tableHeaderRow}>
                  <Text style={styles.tableColHeader1}>SL#</Text>
                  <Text style={styles.tableColHeader}>Date</Text>
                  <Text style={styles.tableColHeaderSmall}>Project</Text>
                  <Text style={styles.tableColHeaderDescription}>Description</Text>
                  <Text style={styles.tableColHeader2}>E.Hrs</Text>
                  <Text style={styles.tableColHeader2}>A.Hrs</Text>
                  <Text style={styles.tableColHeader}>Comp.Date</Text>
                  <Text style={styles.tableColHeaderSmall}>Appr by</Text>
                  <Text style={styles.tableColHeader}>Appr date</Text>
                </View>
              </View>
              {records.map((row, index) => (
                <View key={index} style={styles.tableRow} wrap={false}>
                  {/* <Text style={styles.tableCol1}>{row.SLNO}</Text> */}
                  <Text style={styles.tableCol1}>{index + 1}</Text>
                  <Text style={styles.tableCol}>{row.DATE}</Text>
                  <Text style={styles.tableColSmall}>{row.ProjectCode}</Text>
                  <Text style={styles.tableColDescription}>{row.Comments}</Text>
                  <Text style={styles.tableCol1hrs}>{row.EStimatedHourse}</Text>
                  <Text style={styles.tableCol1hrs}>{row.ActualHourse}</Text>
                  <Text style={styles.tableCol}>{row.CurrectCompletedDate}</Text>
                  <Text style={styles.tableColSmall}>{row.ManagerCode}</Text>
                  <Text style={styles.tableCol}>{row.ApprovedDate}</Text>
                </View>
              ))}
            </View>


            {/* FOOTER */}
            <View fixed
              // style={styles.footerWrapper}
              style={{
                position: "absolute",
                bottom: 15,
                left: 5,
                right: 5,
                height: footerHeight, // 🔥 dynamic
              }}
            >
              {filters.FooterImg && (
                <Image
                  src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                  style={{ width: "100%", height: "100%", }}
                />
              )}
            </View>
            <View
              fixed
              style={{
                position: "absolute",
                bottom: 5,
                left: 0,
                right: 0,
                textAlign: "center",
                fontSize: 10,
              }}
            >
              <Text
                render={({ pageNumber, totalPages }) =>
                  `Page ${pageNumber} of ${totalPages}`
                }
              />
            </View>

          </Page>
        );
      })}

      {/* ================= EMPLOYEE TASKS ================= */}
      <Page size="A4" orientation="landscape"
        // style={styles.page}
        style={{
          paddingBottom: footerHeight,
          paddingTop: 90,
          paddingHorizontal: 20,
          fontSize: 10,
        }}

      >
        <View fixed style={styles.headerWrapper}>
          {filters.HeaderImg && (
            <Image src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`} style={styles.headerImage} />
          )}
        </View>

        <Text style={styles.empheaderText}>Employee Tasks Efforts</Text>

        <View style={styles.emptableContainer}>
          <View style={styles.emptableRow}>
            <Text style={styles.emptableColHeader1}>SL#</Text>
            <Text style={styles.emptableColHeaderProject}>Project</Text>
            <Text style={styles.emptableColHeaderEmp}>Employee Name</Text>
            <Text style={styles.emptableColHeaderhrs}>Total E.Hrs</Text>
            <Text style={styles.emptableColHeaderTotlActhrs}>Total A.Hrs</Text>
          </View>

          {employeeTaskData.map((row, index) => (
            <View key={index} style={styles.emptableRow}>
              <Text style={styles.emptableCol1}>{index + 1}</Text>
              <Text style={styles.emptableColProject}>{row.ProjectName}</Text>
              <Text style={styles.emptableColEmp}>{row.EmployeeName}</Text>
              <Text style={styles.emptableCol1hrs}>{row.TotalEstimatedHours}</Text>
              <Text style={styles.emptableCol1ToalActhrs}>{row.TotalActualHours}</Text>
            </View>
          ))}
        </View>

        <View fixed
          // style={styles.footerWrapper}
          style={{
            position: "absolute",
            bottom: 15,
            left: 5,
            right: 5,
            height: footerHeight, // 🔥 dynamic
          }}
        >
          {filters.FooterImg && (
            <Image
              src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
              style={{ width: "100%", height: "100%", }}
            />
          )}
        </View>
        <View
          fixed
          style={{
            position: "absolute",
            bottom: 5,
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 10,
          }}
        >
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View>
      </Page>

      {/* ================= PROJECT TASKS ================= */}
      <Page size="A4" orientation="landscape"
        // style={styles.page}
        style={{
          paddingBottom: footerHeight,
          paddingTop: 90,
          paddingHorizontal: 20,
          fontSize: 10,
        }}
      >
        <View fixed style={styles.headerWrapper}>
          {filters.HeaderImg && (
            <Image src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`} style={styles.headerImage} />
          )}
        </View>

        <Text style={styles.prjheaderText}>Project Tasks Efforts</Text>

        <View style={styles.prjtableContainer}>
          <View style={styles.prjtableRow}>
            <Text style={styles.prjtableColHeader1}>SL#</Text>
            <Text style={styles.prjtableColHeaderProject}>Project</Text>
            {/* <Text style={styles.prjtableColHeaderEmp}>Employee Name</Text> */}
            <Text style={styles.prjtableColHeaderhrs}>Total E.Hrs</Text>
            <Text style={styles.prjtableColHeadeProjActrhrs}>Total A.Hrs</Text>
          </View>

          {projectTaskData.map((row, index) => (
            <View key={index} style={styles.prjtableRow}>
              <Text style={styles.prjtableCol1}>{index + 1}</Text>
              <Text style={styles.prjtableColProject}>{row.ProjectName}</Text>
              {/* <Text style={styles.prjtableColEmp}>{row.EmployeeName}</Text> */}
              <Text style={styles.prjtableCol1hrs}>{row.TotalEstimatedHours}</Text>
              <Text style={styles.prjtableCol1ProjActhrs}>{row.TotalActualHours}</Text>
            </View>
          ))}
        </View>

        <View fixed
          // style={styles.footerWrapper}
          style={{
            position: "absolute",
            bottom: 15,
            left: 5,
            right: 5,
            height: footerHeight, // 🔥 dynamic
          }}
        >
          {filters.FooterImg && (
            <Image
              src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
              style={{ width: "100%", height: "100%", }}
            />
          )}
        </View>
        <View
          fixed
          style={{
            position: "absolute",
            bottom: 5,
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 10,
          }}
        >
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View>
      </Page>

    </Document>
  );
};

export default PSRreportPageBreak_v1;